<template>
  <div
    class="profil-selector selector"
    :class="{ missing: !classified.profil && showWarnings }"
  >
    <div class="pa-block">
      <h3 class="selector-title">Votre profil</h3>
      <div class="pa-block__inner">
        <fieldset>
          <legend class="title">Vous êtes :</legend>
          <div
            class="pa-block__row"
            :class="{
              active: profil == 'proflib',
              inactive: profil != 'proflib',
            }"
          >
            <input
              type="radio"
              name="profil"
              id="profil-proflib"
              value="proflib"
              v-model="profil"
            />
            <label for="profil-proflib">
              <strong>Professionnel de santé</strong
              ><em>
                (chirurgien-dentiste, prothésiste, assistant-e dentaire...)</em
              >
            </label>
          </div>
          <!-- .pa-block__row -->
          <div
            class="pa-block__row"
            :class="{
              active: profil == 'recruiter',
              inactive: profil != 'recruiter',
            }"
          >
            <input
              type="radio"
              name="profil"
              id="profil-recruiter"
              value="recruiter"
              v-model="profil"
            />
            <label for="profil-recruiter">
              <strong>Établissement</strong
              ><em>
                (collectivité, établissement de santé, mutuelle,
                entreprise...)</em
              >
            </label>
          </div>
          <!-- .pa-block__row -->
        </fieldset>
        <div class="required" :if="!classified.profil">Champ non renseigné</div>
      </div>
      <!-- .pa-block__inner -->
    </div>
    <!-- .pa-block -->
  </div>
  <!-- .profil-selector -->
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "profil-selector",
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  created() {
    if (!this.classified.profil && this.getPreset.profil)
      this.$store.commit("setProfil", this.getPreset.profil);
  },
  mounted() {
    this.$scrollTo("#main"); //, 300, { easing: "ease" });
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getPreset"]),
    profil: {
      get() {
        return this.$store.state.classified.profil;
      },
      set(profil) {
        this.$store.commit("setProfil", profil);
      },
    },
  },
};
</script>
